import React from "react";
import { useNavigate } from "react-router-dom";
import {
  PlayCircleIcon,
  BookOpenIcon,
  ClockIcon,
} from "@heroicons/react/24/outline";

function CourseCard({ course }) {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/cursos/${course.id}`);
  };

  return (
    <div
      onClick={handleClick}
      className="cursor-pointer bg-white shadow-md rounded-xl p-6 border border-gray-100 hover:shadow-lg hover:-translate-y-1 transition-all duration-200"
    >
      <div className="flex items-center gap-3 mb-4">
        <div className="w-12 h-12 bg-indigo-100 text-indigo-600 flex items-center justify-center rounded-full">
          <PlayCircleIcon className="w-7 h-7" />
        </div>

        <h3 className="text-xl font-bold text-gray-900">
          {course.title}
        </h3>
      </div>

      {/* Progresso */}
      <p className="text-sm text-gray-600 mb-1">
        Progresso: {course.progress}%
      </p>

      <div className="w-full bg-gray-200 h-2 rounded-full mb-4">
        <div
          className="bg-indigo-600 h-2 rounded-full transition-all"
          style={{ width: `${course.progress}%` }}
        />
      </div>

      {/* Aulas e horas */}
      <div className="flex items-center justify-between text-gray-500 text-sm mt-4 border-t pt-4">
        <span className="flex items-center gap-1">
          <BookOpenIcon className="w-5 h-5" />
          {course.lessonsCount ?? 0} Aulas
        </span>

        <span className="flex items-center gap-1">
          <ClockIcon className="w-5 h-5" />
          {course.durationHours ?? 0} h
        </span>
      </div>
    </div>
  );
}

export default CourseCard;
